import { useMemo } from 'react';
import { useGetCalendarEvents } from '../../providers/queries/calendar';
import {
  compareEvent,
  isNextWeekEvent,
  isOnGoingEvent,
  isTomorrowEvent,
  isWithinADayEvent,
  isWithinAWeekEvent,
} from '../../utils/calendar/helper';
import {
  getCurrentPSTDateStart,
  getCurrentPSTWeekStart,
} from '@wwe-portal/utils/date';

export const useGetCalendarEvent = () => {
  const { data } = useGetCalendarEvents();
  const events = data?.data || [];
  const { startPSTDate, startPSTWeek } = useMemo(() => {
    return {
      startPSTDate: getCurrentPSTDateStart().getTime(),
      startPSTWeek: getCurrentPSTWeekStart().getTime(),
    };
  }, []);
  const eventsTypes = useMemo(() => {
    return {
      onGoingEvents: events
        .filter((event) => isOnGoingEvent(event, { startPSTDate }))
        .sort(compareEvent),
      today: events
        .filter((event) => isWithinADayEvent(event, { startPSTDate }))
        .sort(compareEvent),
      tomorrow: events
        .filter((event) => isTomorrowEvent(event, { startPSTDate }))
        .sort(compareEvent),
      thisWeek: events
        .filter((event) => isWithinAWeekEvent(event, { startPSTWeek }))
        .sort(compareEvent),
      nextWeek: events
        .filter((event) => isNextWeekEvent(event, { startPSTWeek }))
        .sort(compareEvent),
    };
  }, [events, startPSTDate, startPSTWeek]);

  return {
    eventsTypes,
  };
};
